import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { PublicShell } from "@/public/PublicChrome";
import { Section, Eyebrow, Lede, Reveal, Disclaimer, RelatedLinks } from "@/public/ui";
import { SEO, GLOSSARY } from "@/public/seo";
import { GLOSSARY_TERMS } from "@/public/glossaryTerms";

const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export default function Glossary() {
  return (
    <PublicShell>
      <Seo {...SEO.glossary} noindex={false} />
      <Section className="pt-32 sm:pt-40 pb-10">
        <div className="absolute inset-x-0 top-0 -z-10 h-[380px] bg-[radial-gradient(ellipse_at_top,rgba(6,182,212,0.10),transparent_65%)]" aria-hidden="true" />
        <Reveal><Eyebrow>Glossary</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.08] text-tc-txt">
            The language of the craft.
          </h1>
        </Reveal>
        <Reveal delay={0.1}>
          <Lede className="mt-6 max-w-2xl">
            Concise, factual definitions of the concepts behind TRADECRAFT — AI-native market
            intelligence, deterministic evidence, and the process language used throughout the product.
          </Lede>
        </Reveal>
      </Section>

      <Section className="pb-16">
        <h2 className="font-heading text-xl font-bold text-tc-txt">Beginner trading terms</h2>
        <ul className="mt-4 flex flex-wrap gap-2" data-testid="glossary-beginner-terms">
          {GLOSSARY_TERMS.map((t) => (
            <li key={t.slug}>
              <Link to={`/glossary/${t.slug}`} data-testid={`glossary-link-${t.slug}`}
                className="inline-block rounded-lg border border-white/12 px-3 py-1.5 text-sm text-tc-txt hover:border-tc-coach/50 transition-colors">{t.term}</Link>
            </li>
          ))}
        </ul>
        <h2 className="mt-12 font-heading text-xl font-bold text-tc-txt">TRADECRAFT concepts</h2>
        <dl className="mt-4 grid sm:grid-cols-2 gap-x-10 gap-y-8 border-t border-white/8 pt-10" data-testid="glossary-list">
          {GLOSSARY.map(([term, def, to], i) => (
            <Reveal key={term} delay={Math.min(i, 6) * 0.03} as="div">
              <dt id={slug(term)} className="font-heading font-semibold text-tc-txt scroll-mt-24" data-testid={`glossary-term-${slug(term)}`}>
                {term}
              </dt>
              <dd className="mt-2 text-sm text-tc-sub leading-relaxed">
                {def}
                {to && (
                  <>
                    {" "}
                    <Link to={to} className="text-tc-coach underline-offset-4 hover:underline">Learn more</Link>.
                  </>
                )}
              </dd>
            </Reveal>
          ))}
        </dl>
        <Disclaimer className="mt-10">
          Educational definitions describing TRADECRAFT concepts. Not financial advice; no real-money
          execution; no guaranteed outcomes.
        </Disclaimer>
      </Section>

      <RelatedLinks
        links={[
          ["Market Intelligence", "/intelligence"],
          ["Analyst", "/analyst"],
          ["How It Works", "/how-it-works"],
          ["Learn", "/learn"],
        ]}
      />
    </PublicShell>
  );
}
